import { apiClient } from "../../../lib/apiClient";
import type { ApiResponse } from "../../../types/apiResponse";

export const deleteQuoteProduct = (id_quote_product: number) => {
   return apiClient<ApiResponse>(`/v1/quote/product/${id_quote_product}`, {
      method: "DELETE"
   })
}
